import { Injectable } from '@angular/core';
import { AlertType, PDialogService, PSnackbarComponent } from '@frontend-site/ui/components';
import { ViewAllLicensesDialogComponent } from '@frontend-site/users/features';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SessionRepository } from '@frontend-site/shared/core';
import { Recommendation } from '@frontend-site/recommendations/domain';

@Injectable({ providedIn: 'root' })
export class LicensesService {
    companyId = this.session.applicationConfig?.companyId;
    ref: MatSnackBarRef<PSnackbarComponent> | undefined;
    constructor(
        private snackbar: MatSnackBar,
        private $translate: TranslateService,
        private readonly session: SessionRepository,
        private dialog: PDialogService
    ) {}

    showLicensesRecommendation(recommendations: Recommendation) {
        const daysDistance = this.getDaysDistance(recommendations);
        if (daysDistance && daysDistance > 0) {
            this.ref = this.snackbar.openFromComponent(PSnackbarComponent, {
                panelClass: ['p-alert', `p-alert-medium`, `p-alert-height`],
                verticalPosition: 'top',
                data: {
                    msgMain: this.$translate.instant('AccountRecommendation.PANAYA_LICENSE_EXPIRES', { count: daysDistance }),
                    actionText: this.$translate.instant('AccountRecommendation.PANAYA_LICENSE_VIEW'),
                    type: AlertType.Medium,
                    action: () => this.viewAllLicenses()
                }
            });
        }
    }

    viewAllLicenses() {
        if (this.ref) {
            this.ref.dismiss();
        }
        const companyId = this.companyId;
        const config = { panelClass: 'p-dialog-medium', data: { companyId } };
        this.dialog.open(ViewAllLicensesDialogComponent, config);
    }

    getDaysDistance(recommendations: Recommendation): number | undefined {
        let daysDistance;
        const furthestEndDateStr = JSON.parse(recommendations.contextParameters).furthestEndDate;
        if (furthestEndDateStr) {
            const now = new Date();
            const later = new Date(furthestEndDateStr);
            daysDistance = Math.ceil((later?.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        }
        return daysDistance;
    }
}
